// test499
(499 && 0);
